import { render, staticRenderFns } from "./apps-cards.vue?vue&type=template&id=eb481a22&scoped=true"
import script from "./apps-cards.vue?vue&type=script&lang=js"
export * from "./apps-cards.vue?vue&type=script&lang=js"
import style0 from "./apps-cards.vue?vue&type=style&index=0&id=eb481a22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb481a22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
